import { Stack } from "@altimateai/lego";
import { Badge } from "@altimateai/lego";
import { ReactNode } from "react";

interface ConnectionHeaderProps {
  datastoreName: string;
  icon: ReactNode;
}

export const ConnectionHeader = ({ datastoreName, icon }: ConnectionHeaderProps) => {
  return (
    <Stack direction="row" justify="between" className="al-items-center">
      <h3>Connection</h3>
      <Badge variant="default" className="al-m-2">
        <Stack direction="row" className="al-items-center al-p-2">
          {icon}
          <span className="al-text-sm">{datastoreName}</span>
        </Stack>
      </Badge>
    </Stack>
  );
};
